import HttpClient from "../services/HttpClient";

import {
  APP_URL,
  APP_URL_CONTRACT,
  USUARIOS,
  EXTERNAL,
  PERSONBYDOCUMENTANDTYPE,
  ERROR_MESSAGE,
  USERINTERNAL,
  USERSEARCH,
  USER,
  USERNAME,
} from "../constants";

export const getUsers = () => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${USUARIOS}/`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getById = (id) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${USUARIOS}/${id}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const createUser = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${USUARIOS}${EXTERNAL}`, body, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const updateUser = (body) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL}${USUARIOS}`, body, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const getPersonByDocumentAndType = (document, type, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL}${PERSONBYDOCUMENTANDTYPE}?document=${document}&type=${type}`,

      headers
    )
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getInfoUserInternal = (document, type, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL}${PERSONBYDOCUMENTANDTYPE}?document=${document}&type=${type}`,

      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getInfoEmployeeInternal = (document, type, dispatch) => {
  return new Promise((resolve, reject) => {
    const url = "/employee/internal/by-document/";
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL_CONTRACT}${url}${type}/${document}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getAllInfoUser = (username, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL}${USER}${USERNAME}${username}`,

      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const createUserInternal = (body, token) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    HttpClient.post(`${APP_URL}${USERINTERNAL}`, body, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const getFilterUsers = (filters, paginator) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL}${USERSEARCH}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const deleteUser = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.delete(`${APP_URL}/user/${body}`, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const getUsername = (username) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}/user/${username}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const updateUserInternal = (body) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL}/user/`, body, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const getUserById = (id) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${USER}${id}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};
